import axios from 'axios';

const API_URL = '/api/super-admin';

export const fetchPlatformStats = async () => {
  const { data } = await axios.get(`${API_URL}/stats`);
  return data;
};

export const fetchAvailableDatabases = async () => {
  const { data } = await axios.get(`${API_URL}/databases/available`);
  return data;
};

export const fetchDatabaseUsers = async (dbName) => {
  const { data } = await axios.get(`${API_URL}/databases/${encodeURIComponent(dbName)}/users`);
  return data;
};

export const fetchLinkableAccounts = async (search = '') => {
  const { data } = await axios.get(`${API_URL}/accounts/linkable`, {
    params: search ? { search } : {},
  });
  return data;
};

export const fetchBusinesses = async (params = {}) => {
  const { data } = await axios.get(`${API_URL}/businesses`, { params });
  return data;
};

export const fetchBusinessById = async (id) => {
  const { data } = await axios.get(`${API_URL}/businesses/${id}`);
  return data;
};

export const createBusiness = async (payload) => {
  const { data } = await axios.post(`${API_URL}/businesses`, payload);
  return data;
};

export const updateBusiness = async (id, payload) => {
  const { data } = await axios.patch(`${API_URL}/businesses/${id}`, payload);
  return data;
};

export const resendBusinessInvite = async (id, accountId = null) => {
  const { data } = await axios.post(`${API_URL}/businesses/${id}/resend-invite`, {
    accountId,
  });
  return data;
};

export const fetchBusinessAccounts = async (id) => {
  const { data } = await axios.get(`${API_URL}/businesses/${id}/accounts`);
  return data;
};
